import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ProductType,
} from 'app/enums/label.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    SCPreBookingsFilterRequestResponse,
} from 'app/Apps/ContainerManagement/ServiceCenters/components/PreBookings/PreBookings.types'

const columns: SkyDataGridColumnDefinition<SCPreBookingsFilterRequestResponse>[] = [
    {
        name: 'preBookingNumber',
        labelKey: 'PREBOOKING_NUMBER',
        sorting: false,
    },
    {
        name: 'originAirportIataCode',
        filterField: 'originAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'ORIGIN_AIRPORT',
        sorting: false,
    },
    {
        name: 'destinationAirportIataCode',
        filterField: 'destinationAirportIataCode',
        filterType: FilterType.Array,
        labelKey: 'DESTINATION_AIRPORT',
        sorting: false,
    },
    {
        name: 'customerExecution',
        filterType: FilterType.Array,
        filterField: 'customerExecution',
        labelKey: 'CUSTOMER_EXECUTION',
        sorting: false,
        minWidth: 250,
    },
    {
        name: 'requestedHandover',
        labelKey: 'REQUESTED_HANDOVER',
        filterField: 'requestedHandover',
        filterType: FilterType.DateRange,
        componentName: 'DateTimeCell',
        sorting: false,
        width: 200,
    },
    {
        name: 'requiredContainers',
        componentName: 'RequiredContainersList',
        allowedValuesEnum: ProductType,
        sorting: false,
        labelKey: 'REQUIRED_CONTAINERS',
        filterField: 'requiredContainersProductType',
        filterType: FilterType.Array,
    },
]

export default columns
